// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, { FC } from 'react';

import { StyledHeader } from './Styled';
import LogoAthome from '../../icons/LogoAthome';
import { Container } from '../../../styles/chime-react/CommonStyles';

export const AthomeHeader: FC = () => {
  return (
    <StyledHeader>
      <Container maxWidth="67.5rem">
        <LogoAthome />
      </Container>
    </StyledHeader>
  );
};

AthomeHeader.displayName = 'AthomeHeader';

export default AthomeHeader;
